import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutContent from "../components/AboutContent";
import Services from "../components/Services";
import CaseStudies from "../components/CaseStudies";
import Pricing from "../components/Pricing";
import StatsAndProcess from "../components/StatsAndProcess";
import Testimonials from "../components/Testimonials";
import TrustedClients from "../components/TrustedClients";
import VideoTestimonials from "../components/VideoTestimonials";
import Contact from "../components/Contact";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';


const About = () => {
    return (
        <div className="text-white min-h-screen relative z-10">
            <Navbar />
            <Hero
                badge="About Us"
                title={<>Transform Your <br /> <span className="text-[#F2B135]">Digital Vision</span> <br /> Into Reality.</>}
                subtitle="RojrzTech is a leading software and digital marketing agency specializing in custom Web Development and Branding."
                image="/about.jpeg"

                // Buttons
                primaryBtnText="Start Your Project"
                primaryBtnLink="/contact"
                secondaryBtnText="See Our Portfolio"
                secondaryBtnLink="/portfolio"

                // Cards data
                rating="4.9/5"
                clientCount="49+ Worldwide"
            />
            <main className="relative z-10 w-full">
                <AboutContent />
                <Services />
                <CaseStudies />
                <Pricing />
                <StatsAndProcess />
                <VideoTestimonials />
                <Testimonials />
                <TrustedClients />
                <Contact />
                <CTA />
                <Footer />
                <WhatsAppButton />
            </main>
        </div>
    );
};


export default About;